import React from 'react';
import {ChevronLeft} from 'lucide-react';

type Props = {
  onBack: () => void;
};

const BackButton = ({onBack}: Props) => {
  return (
    <button
      type='button'
      onClick={onBack}
      className='flex items-center gap-1 text-xs text-iq-grey-medium hover:text-iq-black transition-colors mb-4'>
      <ChevronLeft className='w-3 h-3' />
      Back
    </button>
  );
};

export {BackButton};
